// Copyright 2016 BatchGeo LLC

// These are legacy globals that have not yet been able to be removed yet. Below
// we check if these exists on `window` and if not we set them to these values
// set here. Ultimately this entire file should be deleted at some point in the
// future once we can set these properly.
var defaultGlobals = {
  working: 0,
  bounds: undefined,
  clarker: undefined,
  omni: undefined,
  dupes: undefined,
  language: undefined,
  printMode: undefined,
  metrics: undefined,
  per: {
    /**
     * Mutable array of non-thematic colors that the user impacts via the map/edit view
     */
    colors: [
      "red",
      "blue",
      "green",
      "yellow",
      "purple",
      "paleblue",
      "orange",
      "brown",
      "darkgreen",
      "pink",
    ],
    /**
     * Mutable array of thematic colors that the user impacts via the map/edit view
     */
    thematicColors: [
      "red",
      "orange",
      "yellow",
      "green",
      "paleblue",
      "blue",
      "purple",
    ],
  },
  /**
   * Mutable array of non-thematic hex colors that is updated when `per.colors` is mutated.
   */
  hex: [
    "fd7569",
    "6996fd",
    "95ea7b",
    "fdeb5a",
    "c699fd",
    "bae1fd",
    "fb8b07",
    "c79a79",
    "00bd00",
    "faa9fc",
  ],
  /**
   * Mutable array of thematic hex colors that is updated when `per.thematicColors` is mutated.
   */
  thematicHexArray: [
    "FD7569",
    "FB8B07",
    "FDEB5A",
    "95EA7B",
    "BAE1FD",
    "6996FD",
    "C599FE",
  ],
  /**
   * 	Array of available colors in the BatchGeo app. Do not mutate.
   */
  colorPallet: [
    "red",
    "blue",
    "green",
    "yellow",
    "purple",
    "paleblue",
    "orange",
    "brown",
    "darkgreen",
    "pink",
  ],
  /**
   * Array of hex values for the `colorPallet` array. Do not mutate.
   */
  hexArray: [
    "fd7569",
    "6996fd",
    "95ea7b",
    "fdeb5a",
    "c699fd",
    "bae1fd",
    "fb8b07",
    "c79a79",
    "00bd00",
    "faa9fc",
  ],
  /**
   * Array of colors used by the distance calculation tools
   */
  heatColors: ["darkgreen", "green", "yellow", "orange", "red"],
  /**
   * Hex values for the heatColors array.
   */
  heatHexArray: ["00bd00", "95ea7b", "fdeb5a", "fb8b07", "db7569"],
  accuracy_name: "bg_accuracy",
  rgn: "",
  openRow: -1,
  openLocator: 0,
  geocodingEnabled: false,
  base: "",
  styles: {
    simple: [
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { saturation: -50 }],
      },
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ saturation: -20 }],
      },
    ],
    midnight: [
      { featureType: "water", stylers: [{ color: "#021019" }] },
      { featureType: "landscape", stylers: [{ color: "#08304b" }] },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#0c4152" }, { lightness: 5 }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#0b434f" }, { lightness: 25 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ color: "#0b3d51" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }],
      },
      { elementType: "labels.text.fill", stylers: [{ color: "#ffffff" }] },
      {
        elementType: "labels.text.stroke",
        stylers: [{ color: "#000000" }, { lightness: 13 }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#146474" }],
      },
      {
        featureType: "transit",
        elementType: "labels.text.fill",
        stylers: [{ color: "#ffffff" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#144b53" }, { lightness: 14 }, { weight: 1.4 }],
      },
    ],
    grayscale: [
      {
        featureType: "landscape",
        stylers: [
          { saturation: -100 },
          { lightness: 65 },
          { visibility: "on" },
        ],
      },
      {
        featureType: "poi",
        stylers: [
          { saturation: -100 },
          { lightness: 51 },
          { visibility: "simplified" },
        ],
      },
      {
        featureType: "road.highway",
        stylers: [{ saturation: -100 }, { visibility: "simplified" }],
      },
      {
        featureType: "road.arterial",
        stylers: [
          { saturation: -100 },
          { lightness: 30 },
          { visibility: "on" },
        ],
      },
      {
        featureType: "road.local",
        stylers: [
          { saturation: -100 },
          { lightness: 40 },
          { visibility: "on" },
        ],
      },
      {
        featureType: "transit",
        stylers: [{ saturation: -100 }, { visibility: "simplified" }],
      },
      {
        featureType: "administrative.province",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "water",
        elementType: "labels",
        stylers: [
          { visibility: "on" },
          { lightness: -25 },
          { saturation: -100 },
        ],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ hue: "#ffff00" }, { lightness: -25 }, { saturation: -97 }],
      },
    ],
    subtle: [
      { featureType: "poi", stylers: [{ visibility: "off" }] },
      { stylers: [{ saturation: -70 }, { lightness: 37 }, { gamma: 1.15 }] },
      {
        elementType: "labels",
        stylers: [{ gamma: 0.26 }, { visibility: "off" }],
      },
      {
        featureType: "road",
        stylers: [
          { lightness: 0 },
          { saturation: 0 },
          { hue: "#ffffff" },
          { gamma: 0 },
        ],
      },
      {
        featureType: "road",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ lightness: 20 }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ lightness: 50 }, { saturation: 0 }, { hue: "#ffffff" }],
      },
      {
        featureType: "administrative.province",
        stylers: [{ visibility: "on" }, { lightness: -50 }],
      },
      {
        featureType: "administrative.province",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative.province",
        elementType: "labels.text",
        stylers: [{ lightness: 20 }],
      },
    ],
    paledawn: [
      {
        featureType: "water",
        stylers: [{ visibility: "on" }, { color: "#acbcc9" }],
      },
      { featureType: "landscape", stylers: [{ color: "#f2e5d4" }] },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#c5c6c6" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#e4d7c6" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#fbfaf7" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#c5dac6" }],
      },
      {
        featureType: "administrative",
        stylers: [{ visibility: "on" }, { lightness: 33 }],
      },
      { featureType: "road" },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "on" }, { lightness: 20 }],
      },
      {},
      { featureType: "road", stylers: [{ lightness: 20 }] },
    ],
    bluewater: [
      {
        featureType: "water",
        stylers: [{ color: "#46bcec" }, { visibility: "on" }],
      },
      { featureType: "landscape", stylers: [{ color: "#f2f2f2" }] },
      {
        featureType: "road",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      { featureType: "road.highway", stylers: [{ visibility: "simplified" }] },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#444444" }],
      },
      { featureType: "transit", stylers: [{ visibility: "off" }] },
      { featureType: "poi", stylers: [{ visibility: "off" }] },
    ],
    printfriendly: [
      {
        featureType: "administrative",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#fcfcfc" }],
      },
      {
        featureType: "landscape.man_made",
        elementType: "geometry.fill",
        stylers: [{ visibility: "simplified" }, { color: "#ffffff" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#fcfcfc" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#dddddd" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#dddddd" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#eeeeee" }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ visibility: "simplified" }, { color: "#dddddd" }],
      },
    ],
  },
};

// Loop through all the defaultGlobal keys and check if window has them assigned
// or not. We need to make sure they are not already defined which is important!
// Some of these values come in async and if you just set them you could
// overwrite the new value with the default value. This is esp troublesome with
// the `per` variable which sometimes (map page) comes in async later.
Object.keys(defaultGlobals).forEach(function (globalKeyName) {
  if (typeof window[globalKeyName] === "undefined") {
    if (BatchGeoStore.getState().App.isDev)
      console.log(
        globalKeyName,
        "was undefined so setting to ",
        defaultGlobals[globalKeyName],
      );
    window[globalKeyName] = defaultGlobals[globalKeyName];
  } else if (
    typeof defaultGlobals[globalKeyName] === "object" &&
    !Array.isArray(defaultGlobals[globalKeyName])
  ) {
    // Merges objects like `window.per` and `defaultGlobals.per` instead of overwritting.
    window[globalKeyName] = {
      ...defaultGlobals[globalKeyName],
      ...window[globalKeyName],
    };
  }
});

Clarker.prototype.MARKER_CLUSTER_IMAGE_PATH_ =
  defaultGlobals.base + "/images/me";
